// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import GoldenFilledSvg from "@fishx/icons-svg/es/asn/GoldenFilled";
import FishxIcon from '../components/FishxIcon';

var GoldenFilled = function GoldenFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: GoldenFilledSvg
  }));
};

GoldenFilled.displayName = 'GoldenFilled';
export default React.forwardRef(GoldenFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/GoldenFilled.js
// module id = 2883
// module chunks = 0